import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { BasePageContent } from '../BasePage';
import { ColorScheme, useBackgroundContext } from '../../contexts/BackgroundContext';
import SparkleButton from '../../components/buttons/SparkleButton';
import BasePageHeader from '../BasePageHeader';
import FooterLinks from '../../components/FooterLinks';

const Homepage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const backgroundContext = useBackgroundContext();

  const path = location.pathname;

  useEffect(() => {
    backgroundContext.setScheme({ scheme: ColorScheme.Welcome });
  }, []);

  const onLoginClick = () => {
    navigate('/events');
  };

  const onCreateClick = () => {
    navigate('/event/create');
  };

  const onGalleryClick = () => {
    navigate('/gallery');
  }

  const isWelcomePage = path.match(/^\/welcome/) !== null;

  return <>
    <BasePageHeader/>
    <BasePageContent $showFooter={false} $wide={true}>
      <ContentContainer>
        <Column>
          <Name>
            Enlighten your events with AI
          </Name>
          <EventsVideoContainer>
            <video src={'https://shine.sunshine.com/assets/video/Onboarding.mp4'} loop autoPlay muted playsInline>
              Your browser does not support the video tag.
            </video>
          </EventsVideoContainer>
        </Column>
        <Column>
          <ButtonWrapper>
            <SparkleButton buttonText="Create your invite" disabled={false} onClick={onCreateClick}/>
          </ButtonWrapper>
          <NoteContainer>
            {
              isWelcomePage ? <>
                <NoteInner>Already a host or guest?</NoteInner>
                <LoginLinkText onClick={onLoginClick}> Login</LoginLinkText>
              </> : <></>
            }
          </NoteContainer>
          <LinkedNote onClick={onGalleryClick}>Inspiration Gallery</LinkedNote>
        </Column>
      </ContentContainer>
    </BasePageContent>
    <FooterLinks/>
  </>;
};

const ContentContainer = styled.div`
  justify-content: center;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const LoginLinkText = styled.span`
  color: var(--shine-highlight-color);
  cursor: pointer;
  font-size: 18px;
  margin-top: 20px;
`;

const LinkedNote = styled.div`
  color: var(--shine-background-text-color);
  padding: 5px;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
`;

const NoteContainer = styled.div`
  margin-bottom: 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 300;
  padding-top: 5px;
`;

const NoteInner = styled.span`
  color: var(--shine-background-text-color);
  font-size: 18px;
  font-weight: 300;
  padding-right: 5px;
  margin-top: 20px;
`;

const EventsVideoContainer = styled.div`
  width: 360px;
  height: 640px;
  overflow: hidden; // This will cut off any overflow from the video
  position: relative; // Needed for absolute positioning of the video inside
  margin-bottom: 20px;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover; // This will cover the whole area without stretching the video
    position: absolute;
    top: 0;
    left: 0;
  }
`;

const Name = styled.div`
  height: 28px;
  margin: 5px 0 20px;
  font-size: 24px;
  font-weight: 600;
  color: var(--shine-background-text-color);;
`;

const ButtonWrapper = styled.div`
  width: 260px;
`;

export default Homepage;
